import { useStoreMobx } from 'mobx/helpers';
import i18n from '@tecma/i18n';

export const useExternalStoreData = () => {
  const store = useStoreMobx();

  const externalStoreData = {
    brokerId: store.brokerId || '',
    demoProjectId: store.demoProject?.id || '',
    projects: store.projects || [],
    loggedUser: store.loggedUser || {
      language: '',
      id: '',
      email: '',
      firstName: '',
      lastName: '',
      project_ids: [],
      role: '',
    },
    forceLogout: store.forceLogout,
    configLanguages: store.configLanguages as string[],
    name: store.name || '',
    i18n,
  };

  return externalStoreData;
};
